import { getComprobanteFiscalClienteDowload, getFactura, deleteFactura, postCargarFactura } from "../services/documentosService";
import { getFacturasAceptadasHistoricoAll } from "../services/invoiceService";

const dataInicial = {
    listFactuasHistorial: [],
    pagina: 0,
    registros: 10,
    busqueda: "NA",
    filtroEstatus: "3",
    total: 0,
    exito: 0,
}

const GET_FACTURACION_HISTORIAL_ALL = "GET_FACTURACION_HISTORIAL_ALL";
const GET_FACTURACION_HISTORIAL_PAGINA = "GET_FACTURACION_HISTORIAL_PAGINA";
const GET_FACTURACION_HISTORIAL_REGISTROS = "GET_FACTURACION_HISTORIAL_REGISTROS";
const GET_FACTURACION_HISTORIAL_BUSQUEDA = "GET_FACTURACION_HISTORIAL_BUSQUEDA";
const CLEAR_FACTURACION_HISTORIAL = "CLEAR_FACTURACION_HISTORIAL";
const GET_FACTURACION_ESTADO_CUENTA_DOWLOAD = "GET_FACTURACION_ESTADO_CUENTA_DOWLOAD"
const POST_FACTURACION_HISTORIAL_VOUCHER = "POST_FACTURACION_HISTORIAL_VOUCHER"
const GET_FACTURACION_HISTORIAL_VOUCHER_DOWLOAD = "GET_FACTURACION_HISTORIAL_VOUCHER_DOWLOAD"
const DELETE_FACTURACION_HISTORIAL_VOUCHER = "DELETE_FACTURACION_HISTORIAL_VOUCHER"
const GET_FACTURACION_HISTORIAL_FILTRO = "GET_FACTURACION_HISTORIAL_FILTRO"
//* Metodos para finanzas
export default function facturacionHistoriaReducer(state = dataInicial, action) {
    switch (action.type) {
        case DELETE_FACTURACION_HISTORIAL_VOUCHER:
            return { ...state, exito: action.payload.exito }
        case GET_FACTURACION_HISTORIAL_VOUCHER_DOWLOAD:
            return { ...state, exito: action.payload.exito }
        case POST_FACTURACION_HISTORIAL_VOUCHER:
            return { ...state, exito: action.payload.exito }
        case GET_FACTURACION_ESTADO_CUENTA_DOWLOAD:
            return { ...state, exito: action.payload.exito }
        case GET_FACTURACION_HISTORIAL_ALL:
            return { ...state, listFactuasHistorial: action.payload.listFactuasHistorial, total: action.payload.total }
        case GET_FACTURACION_HISTORIAL_PAGINA:
            return { ...state, listFactuasHistorial: action.payload.listFactuasHistorial, pagina: action.payload.pagina, total: action.payload.total }
        case GET_FACTURACION_HISTORIAL_REGISTROS:
            return { ...state, listFactuasHistorial: action.payload.listFactuasHistorial, registros: action.payload.registros, total: action.payload.total }
        case GET_FACTURACION_HISTORIAL_BUSQUEDA:
            return { ...state, listFactuasHistorial: action.payload.listFactuasHistorial, busqueda: action.payload.busqueda, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros, filtroEstatus: action.payload.filtroEstatus }
        case GET_FACTURACION_HISTORIAL_FILTRO:
            return { ...state, listFactuasHistorial: action.payload.listFactuasHistorial, busqueda: action.payload.busqueda, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros, filtroEstatus: action.payload.filtroEstatus }
        case CLEAR_FACTURACION_HISTORIAL:
            return { ...state, listFactuasHistorial: action.payload.array, pagina: action.payload.pagina, registros: action.payload.registros, busqueda: action.payload.busqueda }
        default:
            return state;
    }
}
export const obtenerFacturaHistorialFiltroAction = ({ filtroEstatus }) => async (dispatch, getSate) => {
    return await getFacturasAceptadasHistoricoAll({ Referencia: dataInicial.busqueda, IdCatEstatusDevolucion:filtroEstatus, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_HISTORIAL_FILTRO,
            payload: {
                listFactuasHistorial: Response.Facturas,
                total: Response.Total,
                busqueda: dataInicial.busqueda,
                registros: dataInicial.registros,
                pagina: dataInicial.pagina,
                filtroEstatus: filtroEstatus
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerFacturaHistorialAction = () => async (dispatch, getSate) => {
    const { busqueda, pagina, registros, filtroEstatus } = getSate().facturasHistorial
    return await getFacturasAceptadasHistoricoAll({ Pagina: pagina + 1, IdCatEstatusDevolucion: filtroEstatus, Referencia: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_HISTORIAL_ALL,
            payload: {
                listFactuasHistorial: Response.Facturas,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerFacturaHistorialPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { busqueda, registros, filtroEstatus } = getSate().facturasHistorial
    return await getFacturasAceptadasHistoricoAll({ Pagina: Pagina + 1, Referencia: busqueda, IdCatEstatusDevolucion: filtroEstatus, Registros: registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_HISTORIAL_PAGINA,
            payload: {
                listFactuasHistorial: Response.Facturas,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerFacturaHistorialRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { busqueda, pagina, filtroEstatus } = getSate().facturasHistorial
    return await getFacturasAceptadasHistoricoAll({ Referencia: busqueda, IdCatEstatusDevolucion: filtroEstatus, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_HISTORIAL_REGISTROS,
            payload: {
                listFactuasHistorial: Response.Facturas,
                total: Response.Total,
                registros: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerFacturaHistorialBusquedaAction = ({ Referencia }) => async (dispatch, getSate) => {
    return await getFacturasAceptadasHistoricoAll({ Referencia: Referencia, IdCatEstatusDevolucion: dataInicial.filtroEstatus, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_HISTORIAL_BUSQUEDA,
            payload: {
                listFactuasHistorial: Response.Facturas,
                total: Response.Total,
                busqueda: Referencia,
                registros: dataInicial.registros,
                pagina: dataInicial.pagina,
                filtroEstatus: dataInicial.filtroEstatus
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerComprobanteFiscalAction = ({ IdFactura }) => async (dispatch, getSate) => {
    return await getComprobanteFiscalClienteDowload({ IdFactura }).then(Response => {
        dispatch({
            type: GET_FACTURACION_ESTADO_CUENTA_DOWLOAD,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const cargarFacturaAction = ({ Extension, IdFactura, Imagen, Nombre }) => async (dispatch, getSate) => {
    return await postCargarFactura({ Extension, IdFactura, Imagen, Nombre }).then(Resposne => {
        dispatch({
            type: POST_FACTURACION_HISTORIAL_VOUCHER,
            payload: {
                exito: 1
            },
        })
    }).catch(Error => {
        return Error
    })
}
export const eliminarFacturaAction = ({ IdFacturaComprobante }) => async (dispatch, getSate) => {
    return await deleteFactura({ IdFacturaComprobante }).then(Response => {
        dispatch({
            type: DELETE_FACTURACION_HISTORIAL_VOUCHER,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerFacturaDescargaAction = ({ IdFacturaComprobante }) => async (dispatch, getSate) => {
    return await getFactura({ IdFacturaComprobante }).then(Response => {
        dispatch({
            type: GET_FACTURACION_HISTORIAL_VOUCHER_DOWLOAD,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}

